import React from 'react';
import Footer1 from '../../Utils/GenericUI/Footer1';
import SharpFooter from './SharpCustomer/SharpFooter';
export const FooterConfiguration=(props,customerId)=>{
    const config=new Map();
    config.set("",<Footer1 matchFound={props?.matchFound}/>)
    config.set("HCF0999",<Footer1 matchFound={props?.matchFound}/>)
    config.set("HCF0331",<SharpFooter/>)
    let comp=config.get(customerId)
    return comp;
}